<template>
  <div class="right-content clearfix">
    <view-container :loading="loading" :empty="empty || !list.length" :error="error" @retry="loadData">
      <div class="list-container" id="box">
        <div class="list-content clearfix" id="content">
          <ul class="clearfix">
            <li v-for="(item, index) in computedList" :key="index">
              <p>
                <span :title="`${item.storeName}，于${item.breakRuleTime}，因${item.breakRuleContent}，${item.punishMsg}`">
                  {{ item.test }}{{item.storeName}}，
                  于{{item.breakRuleTime}}，
                  因{{item.breakRuleContent}}，
                  被处以{{item.punishMsg}}
                </span>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </view-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import viewContainer from '@/components/viewContainer'
import $ from 'jquery'
export default {
  name: '',
  data () {
    return {
      loading: false,
      empty: false,
      error: false,
      pageModal: {
        pageNo: 1,
        pageSize: 2000
      },
      list: [],
      computedList: [],
      page: 0
    }
  },
  mounted () {
    this.loadData()
  },
  beforeUnmount () {
    clearTimeout(window.timer)
    $('#box').off('mouseenter mouseleave')
  },
  methods: {
    initScroll () {
      let _this = this
      autoScroll()
      $('#box').hover(() => {
        clearTimeout(window.timer)
      }, () => {
        autoScroll()
      })
      function autoScroll () {
        _this.setList()
        let $div = $('#content')
        let top = parseInt($div.css('top'), 10)
        clearTimeout(window.timer)
        window.timer = setTimeout(() => {
          $div.css({
            top: (top - 1) + 'px'
          })
          autoScroll()
        }, 40)
      }
    },
    setList () {
      if (this.list.length <= 15) {
        if (!this.computedList.length) {
          this.computedList = this.list
        }
        return
      } else {
        if (this.page === 0) {
          this.page = 18
          this.computedList = this.list.slice(0, 18)
        }
        let $div = $('#content')
        let top = parseInt($div.css('top'), 10)
        if (Math.abs(top) >= 56) {
          if (this.page === this.list.length) {
            this.page = 0
          }
          $div.css('top', top + 28 + 'px')
          this.computedList.splice(0, 1)
          this.computedList.push(this.list[this.page])
          this.page++
        }
      }
    },
    loadData (autoLoad) {
      const {
        pageNo,
        pageSize
      } = this.pageModal
      if (!autoLoad) {
        this.loading = true
        this.empty = false
        this.error = false
      }
      this.queryViolationAnnouncement({
        pageNo,
        pageSize
      }).then((resp) => {
        let result = resp || {}
        result.dataInfo = result.dataInfo || []
        this.list = this.list.concat(result.dataInfo)
        if (this.list.length > 15 && this.list.length < 30) {
          this.list = this.list.concat(JSON.parse(JSON.stringify(this.list)))
        }
        setTimeout(() => {
          this.setList()
          pageNo === 1 && this.list.length > 15 && this.initScroll()
        }, 500)
        if (!this.list || !this.list.length) {
          this.empty = true
        }
        if (result.hasNext) {
          this.pageModal.pageNo += 1
          this.loadData(true)
        }
      }).catch(() => {
        if (!autoLoad) {
          this.error = true
        } else {
          this.loadData(true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 450)
      })
    },
    ...mapActions({
      queryViolationAnnouncement: 'queryViolationAnnouncement'
    })
  },
  components: {
    viewContainer
  }
}
</script>

<style lang="scss" scoped>
ul {
  float: left;
  width: 100%;
  li {
    float: left;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
    overflow: hidden;
    position: relative;
    > span:first-child {
      float: left;
      font-size: 12px;
      color: #627DB6;
      background: rgba($color: #627DB6, $alpha: 0.1);
      border-radius: 2px;
      padding: 2px 4px;
      line-height: 14px;
    }
    p  {
      padding-left: 0px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 30px;
    }
    > span:nth-child(3) {
      position: absolute;
      top: 0;
      right: 30px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999;
      font-weight: 400;
    }
  }
}
.right-content {
  padding-top: 16px;
}
.list-container {
  position: relative;
  overflow: hidden;
  height: 427px;
  .list-content {
    position: absolute;
    top:0;
    width: 100%;
  }
}
</style>
